// extracted by mini-css-extract-plugin
module.exports = {"menu-link":"MenuLink_menu-link__oM4Je"};